import { Component } from '@angular/core';
import {
  DictionaryPapIndexEntity,
  DictionaryPapIndexDataService,
} from '../../../app/shared';
import {
  DataTableDataDefinition,
  CustomButtonDefinition
} from 'src/app/shared/fca-data-table';
import { DictionaryType } from 'src/components/shared/dictionaries-layout';
import { MatDialog } from '@angular/material/dialog';
import { AddNewPapIndexDialogComponent } from './add-new-pap-index-dialog/add-new-pap-index-dialog.component';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-dictionaries-pap-index-tab',
  templateUrl: './dictionaries-pap-index-tab.html',
  styleUrl: './dictionaries-pap-index-tab.scss'
})
export class DictionariesPapIndexTab {
  pageSize = 10;
  title = 'Dictionary';
  dictionaryType = DictionaryType.PapIndex;
  
  data: DictionaryPapIndexEntity[] = [];

  isDialogOpen = false;

  constructor(
    private dataService: DictionaryPapIndexDataService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  customButtons: CustomButtonDefinition<DictionaryPapIndexEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.onDelete.bind(this) as (x: any) => {},
    },
  ];
  

  dataDefinition: DataTableDataDefinition<DictionaryPapIndexEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'indexName',
          caption: 'Index Name',
          valueType: 'text',
          editable: false,
          deletable: true
        },
        {
          fieldName: 'validSince',
          caption: 'Valid Since',
          valueType: 'date',
          format: 'dd.MM.yyyy',
          editable: false,
          deletable: true
        },
        {
          fieldName: 'indexValue',
          caption: 'Index Value',
          valueType: 'number',
          editable: false,
          deletable: true
        },
        {
          fieldName: 'uoM',
          caption: 'UoM',
          valueType: 'text',
          editable: false,
          deletable: true
        },
      ],
    },
  ];


  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData;
    });
  }

  addPapIndex() {
    const dialogRef = this.dialog.open(AddNewPapIndexDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      scrollStrategy: new NoopScrollStrategy(),
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.loadData();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  onDelete(papIndex: DictionaryPapIndexEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes' && papIndex.id) {
        this.dataService.delete(papIndex.id).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error) => {
            if (error?.error?.ErrorCode === 'ERROR_DELETE_PAP_INDEX') {
              const lines: string[] = error.error.Message.split('\n');
              const records = lines.slice(1).filter((line) => line.trim() !== '');
              const recordsList = records.join('\n');
              const formattedMessage =
                `This PAP Index is currently used in Airport Contract List module for following records:\n\n${recordsList}`;

              this.dialog.open(ConfirmationDialogComponent, {
                width: '350px',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: 'preformatted-dialog',
                data: {
                  title: 'Attention',
                  message: formattedMessage,
                  buttons: {
                    confirm: 'OK',
                  },
                },
              });
            } else {
              this.snackBar.open('An error occurred while deleting the record.', 'Close', { duration: 5000 });
            }
          },
        });
      }
    });
  }
}
